import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';
import type { ChallengeRoomData } from 'src/features/hacktivities/challenges/challenges.types';

export const userReprofilingSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserReprofilingRoomRecommendation: builder.query<ApiResponse<ChallengeRoomData>, void>({
      query: () => ({
        url: 'users/reprofiling/room-recommendation',
      }),
    }),
  }),
});

export const { useGetUserReprofilingRoomRecommendationQuery } = userReprofilingSlice;
